module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/quotas/quota-batchs/quota-movements-batch/quota-movements-batch.component.css
// module id = ./src/app/quotas/quota-batchs/quota-movements-batch/quota-movements-batch.component.css
// module chunks = main